/* =====================================================================
   MOON PEAK — theme behaviour
   No libraries. Transform/opacity only. Every module is idempotent so
   the theme editor can re-run boot() after shopify:section:load.
===================================================================== */
(function () {
  'use strict';

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  function once(el, k) {
    if (!el || el.getAttribute('data-mp-' + k)) return false;
    el.setAttribute('data-mp-' + k, '1');
    return true;
  }

  /* ---------- money ---------- */
  var MONEY = '{{amount}}';
  function money(cents) {
    var fmt = MONEY;
    function fix(n, dec, ts, ds) {
      if (isNaN(n)) return '0';
      n = (n / 100).toFixed(dec);
      var parts = n.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + ts);
      return parts[1] ? head + ds + parts[1] : head;
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var out;
    switch (m && m[1]) {
      case 'amount_no_decimals': out = fix(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fix(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fix(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': out = fix(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = fix(cents, 0, ' ', ','); break;
      default: out = fix(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ---------- 1. reveal on scroll ---------- */
  var io = null;
  function initReveal() {
    var items = $$('.rv, .rv-fade, .rv-mask, .rv-img, .moon-sig').filter(function (el) { return once(el, 'rv'); });
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduced) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    }
    items.forEach(function (el) { io.observe(el); });
    setTimeout(function () { items.forEach(function (el) { el.classList.add('in'); }); }, 5000);
  }

  /* ---------- 2. sequential reveal (manifesto) ---------- */
  function initSequence() {
    $$('[data-sequence]').forEach(function (root) {
      if (!once(root, 'seq')) return;
      var steps = $$('[data-step]', root);
      if (!('IntersectionObserver' in window) || reduced) {
        steps.forEach(function (s) { s.classList.add('in'); });
        return;
      }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          steps.forEach(function (s, i) {
            setTimeout(function () { s.classList.add('in'); }, i * 420);
          });
        });
      }, { threshold: 0.35 }).observe(root);
    });
  }

  /* ---------- 3. scroll parallax ---------- */
  var layers = [], ticking = false;
  function collect() { layers = $$('[data-speed]'); }
  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var hdr = $('.hdr');
    if (hdr) hdr.classList.toggle('stuck', y > 30);
    if (!reduced) {
      for (var i = 0; i < layers.length; i++) {
        var el = layers[i];
        var sp = parseFloat(el.getAttribute('data-speed')) || 0;
        var box = el.parentElement.getBoundingClientRect();
        if (box.bottom < -200 || box.top > innerHeight + 200) continue;
        var mid = box.top + box.height / 2 - innerHeight / 2;
        el.style.transform = 'translate3d(0,' + (-mid * sp).toFixed(1) + 'px,0)';
      }
      peakType();
    }
    ticking = false;
  }
  function initParallax() {
    collect();
    if (once(document.documentElement, 'scroll')) {
      addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
      }, { passive: true });
      addEventListener('resize', collect, { passive: true });
    }
    onScroll();
  }

  /* ---------- 4. peak headline swap ---------- */
  function peakType() {
    $$('[data-peak-type]').forEach(function (t) {
      var box = t.getBoundingClientRect();
      var p = 1 - (box.top + box.height) / (innerHeight + box.height);
      var lead = $('.lead', t), swap = $('.swap', t);
      if (!lead || !swap) return;
      var flip = p > 0.55;
      lead.classList.toggle('off', flip);
      swap.classList.toggle('on', flip);
    });
  }

  /* ---------- 5. hero stars ---------- */
  function initStars() {
    $$('.hero-stars').forEach(function (box) {
      if (!once(box, 'stars')) return;
      var n = reduced ? 0 : (innerWidth < 760 ? 26 : 54);
      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var s = document.createElement('i');
        s.style.left = (Math.random() * 100).toFixed(2) + '%';
        s.style.top = (Math.random() * 62).toFixed(2) + '%';
        s.style.animationDelay = (Math.random() * 6).toFixed(2) + 's';
        s.style.opacity = (0.2 + Math.random() * 0.5).toFixed(2);
        if (Math.random() > 0.82) { s.style.width = '2px'; s.style.height = '2px'; }
        frag.appendChild(s);
      }
      box.appendChild(frag);
    });
  }

  /* ---------- 6. custom cursor ---------- */
  function initCursor() {
    if (!fine || reduced || $('.cursor')) return;
    var c = document.createElement('div');
    c.className = 'cursor hidden';
    c.innerHTML = '<span></span>';
    document.body.appendChild(c);
    var label = c.firstChild;
    var tx = innerWidth / 2, ty = innerHeight / 2, cx = tx, cy = ty;
    addEventListener('pointermove', function (e) {
      tx = e.clientX; ty = e.clientY;
      c.classList.remove('hidden');
    }, { passive: true });
    addEventListener('pointerleave', function () { c.classList.add('hidden'); });
    (function loop() {
      cx += (tx - cx) * 0.18; cy += (ty - cy) * 0.18;
      c.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    })();
    document.addEventListener('pointerover', function (e) {
      var t = e.target.closest ? e.target.closest('[data-cursor],a,button') : null;
      if (!t) { c.classList.remove('big'); label.textContent = ''; return; }
      var txt = t.getAttribute('data-cursor');
      if (txt) { c.classList.add('big'); label.textContent = txt; }
      else { c.classList.remove('big'); label.textContent = ''; }
    });
  }

  /* ---------- 7. page transition ---------- */
  function initVeil() {
    if (reduced || !once(document.body, 'veil')) return;
    var v = document.createElement('div');
    v.className = 'veil';
    document.body.appendChild(v);
    addEventListener('pageshow', function () { v.classList.remove('on'); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || a.target === '_blank' || a.hasAttribute('download')) return;
      if (a.hostname && a.hostname !== location.hostname) return;
      if (a.hasAttribute('data-no-veil')) return;
      e.preventDefault();
      v.classList.add('on');
      setTimeout(function () { location.href = href; }, 380);
    });
  }

  /* ---------- 8. drawers ---------- */
  var openDrawer = null;
  function scrim() {
    var s = $('.scrim');
    if (!s) { s = document.createElement('div'); s.className = 'scrim'; document.body.appendChild(s); s.addEventListener('click', closeDrawers); }
    return s;
  }
  function showDrawer(el) {
    if (!el) return;
    closeDrawers();
    openDrawer = el;
    scrim().classList.add('on');
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('input,button,a');
    if (f) setTimeout(function () { f.focus(); }, 320);
  }
  function closeDrawers() {
    $$('.drawer.on').forEach(function (d) { d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); });
    var s = $('.scrim'); if (s) s.classList.remove('on');
    document.body.style.overflow = '';
    openDrawer = null;
  }
  function initDrawers() {
    if (once(document.documentElement, 'drawers')) {
      addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });
    }
    $$('[data-open]').forEach(function (b) {
      if (!once(b, 'open')) return;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var t = $('#' + b.getAttribute('data-open'));
        if (t === openDrawer) closeDrawers(); else showDrawer(t);
        if (b.getAttribute('data-open') === 'cart-drawer') loadCart();
      });
    });
    $$('[data-close]').forEach(function (b) {
      if (!once(b, 'close')) return;
      b.addEventListener('click', closeDrawers);
    });
  }

  /* ---------- 9. cart ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = false;
    });
  }
  function cartLine(item) {
    var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy" width="74" height="92">' : '<span></span>';
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="v">' + item.variant_title + '</div>' : '';
    return '<div class="cl" data-key="' + item.key + '">' +
      '<a href="' + item.url + '">' + img + '</a>' +
      '<div><a href="' + item.url + '" class="t">' + item.product_title + '</a>' + variant +
        '<div class="row">' +
          '<span class="qty"><button type="button" data-q="-1" aria-label="Reduce quantity">&minus;</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-q="1" aria-label="Increase quantity">+</button></span>' +
          '<span class="p">' + money(item.final_line_price) + '</span>' +
        '</div>' +
        '<div class="row"><button type="button" class="ln" data-q="0">Remove</button></div>' +
      '</div></div>';
  }
  function renderCart(cart) {
    var body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
    setCount(cart.item_count);
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p class="lede">Nothing in the bag yet.</p>' +
        '<a class="btn" href="/collections/all">Explore collection</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(cartLine).join('');
    if (foot) {
      foot.hidden = false;
      var t = $('[data-cart-total]', foot);
      if (t) t.textContent = money(cart.total_price);
    }
  }
  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function addToCart(id, qty, btn) {
    var was = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, b: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.b.description || 'Could not add that');
        return loadCart().then(function () { showDrawer($('#cart-drawer')); });
      })
      .catch(function (err) {
        var s = $('[data-buy-status]');
        if (s) { s.textContent = err.message; s.hidden = false; }
      })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = was; } });
  }
  function initCart() {
    var d = $('#cart-drawer');
    if (d && once(d, 'cart')) {
      d.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-q]') : null;
        if (!b) return;
        var line = b.closest('.cl');
        var key = line.getAttribute('data-key');
        var step = parseInt(b.getAttribute('data-q'), 10);
        var cur = parseInt($('.qty span', line).textContent, 10) || 1;
        changeLine(key, step === 0 ? 0 : Math.max(0, cur + step));
      });
      loadCart();
    }
    $$('[data-quick-add]').forEach(function (b) {
      if (!once(b, 'qa')) return;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(b.getAttribute('data-quick-add'), 1, b);
      });
    });
  }

  /* ---------- 10. predictive search ---------- */
  function initSearch() {
    var box = $('#search-drawer');
    if (!box || !once(box, 'search')) return;
    var input = $('input[name="q"]', box);
    var out = $('[data-sug]', box);
    if (!input || !out) return;
    var timer = null, last = '';
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (q === last) return;
        last = q;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var r = (d.resources && d.resources.results) || {};
            var rows = [];
            (r.products || []).forEach(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '<span></span>';
              rows.push('<a href="' + p.url + '">' + img + '<span class="t">' + p.title + '</span><span class="p">' + (p.price || '') + '</span></a>');
            });
            (r.collections || []).forEach(function (c) {
              rows.push('<a href="' + c.url + '"><span></span><span class="t">' + c.title + '</span><span class="p">Collection</span></a>');
            });
            (r.pages || []).forEach(function (p) {
              rows.push('<a href="' + p.url + '"><span></span><span class="t">' + p.title + '</span><span class="p">Page</span></a>');
            });
            out.innerHTML = rows.length ? rows.join('') : '<p class="sug-empty">Nothing matches that yet.</p>';
          })
          .catch(function () { out.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------- 11. product page ---------- */
  function initProduct() {
    $$('[data-product-root]').forEach(function (root) {
      if (!once(root, 'pdp')) return;
      var raw = $('[data-variants]', root);
      if (!raw) return;
      var variants;
      try { variants = JSON.parse(raw.textContent); } catch (e) { return; }
      var groups = $$('[data-option-index]', root);
      var idField = $('[data-variant-id]', root);
      var priceNow = $('[data-price-now]', root);
      var priceWas = $('[data-price-was]', root);
      var submit = $('[data-buy]', root);
      var status = $('[data-buy-status]', root);
      var current = null;

      function pick() {
        var sel = groups.map(function (g) {
          var on = $('input:checked', g);
          return on ? on.value : null;
        });
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < sel.length; j++) {
            if (sel[j] !== null && variants[i].options[j] !== sel[j]) { ok = false; break; }
          }
          if (ok) return variants[i];
        }
        return null;
      }
      function apply() {
        var v = pick();
        current = v;
        if (status) status.hidden = true;
        if (!v) { if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; } return; }
        if (idField) idField.value = v.id;
        if (priceNow) priceNow.textContent = v.price;
        if (priceWas) { priceWas.textContent = v.compare || ''; priceWas.hidden = !v.compare; }
        if (submit) {
          submit.disabled = !v.available;
          submit.textContent = v.available ? submit.getAttribute('data-label') : 'Sold out';
        }
        if (v.media) {
          var shot = $('[data-media-id="' + v.media + '"]', root);
          if (shot && shot.scrollIntoView) shot.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
        }
        if (history.replaceState) {
          var u = new URL(location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
      }
      groups.forEach(function (g) { g.addEventListener('change', apply); });
      apply();

      var form = $('form[action*="/cart/add"]', root);
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch || !current) return;
          e.preventDefault();
          var q = $('[data-qty]', root);
          addToCart(current.id, q ? parseInt(q.value, 10) || 1 : 1, submit);
        });
      }
    });
  }

  /* ---------- 12. hero: cursor parallax, scroll spin, and drag to turn ---------- */
  function initHero3d() {
    $$('[data-hero-3d]').forEach(function (stage) {
      if (!once(stage, 'hero3d')) return;
      var grid = $('.hl-grid', stage);
      var sway = $('.hl-sway', stage);
      var hero = stage.closest ? stage.closest('.hl') : null;
      if (!hero) hero = stage.parentElement;
      if (!grid || reduced) return;

      var ring = matchMedia('(max-width: 760px)');
      var tx = 0, ty = 0, cx = 0, cy = 0, running = false, visible = true;
      var scrollSpin = 0, dragSpin = 0, dragRy = 0;
      var vel = 0, dragging = false, lastX = 0, glideRaf = 0;

      function paint() {
        // on a phone the frames sit on a ring, so drag and scroll both turn it
        grid.style.setProperty('--spin', (scrollSpin + dragSpin).toFixed(1) + 'deg');
        // on a wider screen the field tilts instead: cursor plus whatever you dragged
        grid.style.setProperty('--ry', (cx * 9 + dragRy).toFixed(2) + 'deg');
        grid.style.setProperty('--rx', (cy * -5.5).toFixed(2) + 'deg');
      }

      /* --- cursor parallax (fine pointers only) --- */
      function frame() {
        cx += (tx - cx) * 0.06;
        cy += (ty - cy) * 0.06;
        paint();
        if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) requestAnimationFrame(frame);
        else running = false;
      }
      function kick() { if (!running) { running = true; requestAnimationFrame(frame); } }

      if (fine) {
        addEventListener('pointermove', function (e) {
          if (!visible || dragging) return;
          tx = (e.clientX / innerWidth - 0.5) * 2;
          ty = (e.clientY / innerHeight - 0.5) * 2;
          kick();
        }, { passive: true });
        addEventListener('pointerleave', function () { tx = 0; ty = 0; kick(); });
      }

      /* --- drag left or right to turn it yourself --- */
      var LIMIT = 34;
      function clampRy(v) { return Math.max(-LIMIT, Math.min(LIMIT, v)); }

      hero.addEventListener('pointerdown', function (e) {
        if (e.target.closest && e.target.closest('a,button,input,select,textarea,summary')) return;
        dragging = true;
        lastX = e.clientX;
        vel = 0;
        cancelAnimationFrame(glideRaf);
        hero.classList.add('dragging');
        try { hero.setPointerCapture(e.pointerId); } catch (err) {}
      });

      hero.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - lastX;
        lastX = e.clientX;
        var k = ring.matches ? 0.55 : 0.16;
        vel = dx * k;
        if (ring.matches) dragSpin += vel; else dragRy = clampRy(dragRy + vel);
        paint();
      });

      function release() {
        if (!dragging) return;
        dragging = false;
        hero.classList.remove('dragging');
        (function glide() {
          vel *= 0.94;
          if (Math.abs(vel) < 0.02) return;
          if (ring.matches) dragSpin += vel; else dragRy = clampRy(dragRy + vel);
          paint();
          glideRaf = requestAnimationFrame(glide);
        })();
      }
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        hero.addEventListener(ev, release);
      });

      /* --- scroll: the ring turns, the desktop field recedes --- */
      if (sway) {
        var onScroll = function () {
          var box = stage.getBoundingClientRect();
          var p = Math.min(1, Math.max(0, -box.top / Math.max(1, box.height)));
          sway.style.setProperty('--depth', (-p * 420).toFixed(1) + 'px');
          scrollSpin = p * 540;
          paint();
        };
        addEventListener('scroll', function () { requestAnimationFrame(onScroll); }, { passive: true });
        onScroll();
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0 }).observe(stage);
      }
    });
  }

  /* ---------- 13. horizontal strip ---------- */
  function initStrip() {
    $$('[data-strip]').forEach(function (wrap) {
      if (!once(wrap, 'strip')) return;
      var lane = $('.strip', wrap);
      if (!lane) return;
      $$('[data-scroll]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = b.getAttribute('data-scroll') === 'next' ? 1 : -1;
          lane.scrollBy({ left: dir * Math.min(lane.clientWidth * 0.8, 700), behavior: reduced ? 'auto' : 'smooth' });
        });
      });
    });
  }

  function boot() {
    MONEY = document.body.getAttribute('data-money-format') || MONEY;
    initReveal(); initSequence(); initParallax(); initStars();
    initCursor(); initVeil(); initDrawers(); initCart();
    initSearch(); initProduct(); initStrip(); initHero3d();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
